export enum FilterTodos {
  All = 'All',
  Active = 'Active',
  Completed = 'Completed',
}
